import React, { memo } from "react"
import PropTypes from "prop-types"

import { Typography, theme } from "@elevate_security/elevate-component-library"
import { SpacingY } from "@src/components/SpacingY"
import { SpacingX } from "@src/components/SpacingX"
import { DateContainer, SubTitle } from "./styles"
import { useTranslation } from "react-i18next"
import { getGlobalConfig } from "@src/globalConfig"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons"

function PageHeader(props) {
  const {
    title,
    subtitle,
    contentOnTheRightOfTitle,
    lastUpdatedTimeLabel,
    renderBanner,
  } = props

  const { t } = useTranslation()

  return (
    <SpacingY>
      {lastUpdatedTimeLabel && (
        <DateContainer>{lastUpdatedTimeLabel}</DateContainer>
      )}
      {renderBanner ? renderBanner() : null}
      <SpacingX justify="space-between" wrap={false}>
        <SpacingY size="xs" style={{ flexShrink: "1" }}>
          {typeof title === "string" ? (
            <Typography.H1
              fontWeight="heavy"
              style={{ color: theme.colors.gray.opaque[900], margin: "0" }}
            >
              {title}
            </Typography.H1>
          ) : (
            title
          )}
          {subtitle && <SubTitle>{subtitle}</SubTitle>}
        </SpacingY>
        <SpacingX alignItems="center" size="lg">
          {contentOnTheRightOfTitle && <div>{contentOnTheRightOfTitle}</div>}
          {getGlobalConfig("SHOW_HEADER_HELP_LINK") && (
            <div>
              <a
                href="https://mimecastsupport.zendesk.com/hc/en-us/articles/34000513740947-Engage-Human-Risk-Dashboard"
                target="_blank"
                rel="noreferrer noopener"
                style={{ fontSize: "14px" }}
              >
                <span style={{ textDecoration: "underline" }}>
                  {t("helpText")}
                </span>
                &nbsp;
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </a>
            </div>
          )}
        </SpacingX>
      </SpacingX>
    </SpacingY>
  )
}

PageHeader.defaultProps = {
  subtitle: null,
  contentOnTheRightOfTitle: null,
  lastUpdatedTimeLabel: null,
  renderBanner: null,
  wrap: true,
}

PageHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  contentOnTheRightOfTitle: PropTypes.node,
  lastUpdatedTimeLabel: PropTypes.string,
  renderBanner: PropTypes.node,
  wrap: PropTypes.bool,
}

export default memo(PageHeader)
